/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { ITableVisualizationWrapperProps } from '../types/tableVisualizationTypes';
import { IVisitorContext } from '../types/tableVisualizationConverterTypes';
import { createGrandTotalRow, createHeaderRow } from './rowFactory';

function createInitialVisitorContext(props: ITableVisualizationWrapperProps): IVisitorContext {
    const {
        dataset, staticProperties
    } = props;

    return {
        addedRowsCount: 0,
        rowsCount: 0,
        lastDetailIndex: -1,
        missingIndex: -1,
        table: {
            header: createHeaderRow(staticProperties),
            rows: [], // populating in visitor
            bottom: createGrandTotalRow(staticProperties, dataset)
        },
        groupTitles: []
    };
}

export default { create: createInitialVisitorContext };
